import React from "react";
import { cn } from "../../../utils/tw";

interface DatePickerProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}

const DatePicker = React.forwardRef<HTMLInputElement, DatePickerProps>(
  ({ label, error, className, id, required, ...props }, ref) => {
    const inputId = id || props.name || label.toLowerCase().replace(/\s+/g, "-");
    return (
      <div className="space-y-1">
        <label
          htmlFor={inputId}
          className="block text-sm font-medium text-text-secondary"
        >
          {label} {required && <span className="text-ds-status-error-main">*</span>}
        </label>
        <input
          ref={ref}
          id={inputId}
          type="date"
          className={cn(
            'w-full border border-border-default bg-bg-surface px-3 py-2 rounded-lg outline-none focus:border-ds-primary-500 focus:ring-1 focus:ring-ds-primary-500/30 min-h-[48px] text-text-primary',
            error && 'border-border-error focus:border-border-error focus:ring-ds-status-error-main/30',
            className
          )}
          required={required}
          {...props}
        />
        {error && <p className="text-ds-status-error-main text-xs">{error}</p>}
      </div>
    );
  }
);
DatePicker.displayName = "DatePicker";

export default DatePicker;
